export const ASSETS_URL = 'https://storage.googleapis.com/headtotoe-dev-app-assets/';

export const ASSETS_TYPES = {
  DASHBOARD_BANNERS: 'dashboard-banners',
  KNOWLEDGE_HUB_LOGO: 'logos/hub',
  ORG_WEB_LOGO: 'logos/web',
};

export const DASHBOARD_BANNERS_PATH = 'dashboard-banners/';
